import { getActionSourceFromCommandingViewMode } from 'owa-command-ribbon';
import {
    isFolderInFavorites,
    isOutlookFavoritingInProgress,
    isPublicFolderInFavorites,
} from 'owa-favorites';
import { isPublicFolder } from 'owa-folders';
import type { MailboxInfo } from 'owa-client-types';
import { shouldShowFavoriteToggle } from 'owa-mail-folder-common';
import { lazyToggleFavoriteFolder } from 'owa-mail-folder-forest-actions';
import getSelectedTableView from 'owa-mail-list-store/lib/utils/getSelectedTableView';
import getSelectedFolder from 'owa-mail-store/lib/utils/getSelectedFolder';
import { lazyRemovePublicFolderFromFavorites } from 'owa-publicfolder-picker';

export async function onToggleSelectedFolderFavorite(mailboxInfo: MailboxInfo): Promise<void> {
    const selectedFolder = getSelectedFolder();
    const folderId = selectedFolder?.id;

    if (
        !selectedFolder ||
        !folderId ||
        !shouldShowFavoriteToggle(mailboxInfo, getSelectedTableView()) ||
        isOutlookFavoritingInProgress(folderId)
    ) {
        return;
    }

    const isFavorite = isPublicFolder(folderId)
        ? isPublicFolderInFavorites(folderId)
        : isFolderInFavorites(folderId);
    if (isPublicFolder(folderId)) {
        if (!isFavorite) {
            return;
        }

        const removePublicFolderFromFavorites = await lazyRemovePublicFolderFromFavorites.import();
        await removePublicFolderFromFavorites(selectedFolder);
        return;
    }

    lazyToggleFavoriteFolder.importAndExecute(
        folderId,
        isFavorite,
        getActionSourceFromCommandingViewMode()
    );
}
